<div class="relative flex justify-end">
  <div #attractionMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="open"
       (click)="handleOpen($event, attractionMenuTrigger)"
       class="flex items-center underline cursor-pointer">
    <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="AI" class="m-r-1"
         width="22px" height="22px">
    {{ triggerText }}
  </div>

  <mat-menu #menu="matMenu"
            class="ig-text-color-edit ig-menu-3 ig-attraction-description-generator-menu" igClickStopPropagation>

    <p class="!mb-2 font-semibold">Generate attraction content using AI</p>

    @if (itinerary?.attractions.length) {
      <div *ngFor="let stop of itinerary.attractions;let i = index" class="flex" igClickStopPropagation>
        <div class="border-l-[1px] border-dashed border-gray-300">
          <div
            class="w-7 h-7 rounded-full bg-gray-300 font-semibold flex items-center justify-center -translate-x-3.5">{{ i + 1 }}
          </div>
        </div>

        <div class="flex flex-col">
          <b>{{ stop.item.name }}</b>
          <mat-checkbox class="" [checked]="isSelected(stop.item._id, 'pre')"
                        (change)="selectItem($event, stop.item, 'pre')">
            Pre-description
          </mat-checkbox>
          <mat-checkbox class="" [checked]="isSelected(stop.item._id, 'desc')"
                        (change)="selectItem($event, stop.item, 'desc')">
            Attraction description
          </mat-checkbox>
          <mat-checkbox class="" [checked]="isSelected(stop.item._id, 'post')"
                        (change)="selectItem($event, stop.item, 'post')">
            Post-description
          </mat-checkbox>
        </div>
      </div>

    }
    <mat-checkbox [(ngModel)]="selectAll" class="block my-2 -translate-x-[18px]" [checked]="false"
                  igClickStopPropagation (change)="selectAllChange($event)">
      Select all
    </mat-checkbox>
    <ig-button isAsync="true" (trigger)="generate($event, attractionMenuTrigger)" class="block mb-2">Generate
    </ig-button>

  </mat-menu>

</div>
